(function () {
  'use strict';

  function cartDrawerSections() {
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function refreshDrawer(parsedState) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(parsedState);
    }
  }

  // Dawn's quantity-input never decrements below the variant's min (1 for
  // a normal item), so clicking "-" at 1 is a silent no-op — the trash
  // icon is the only way to remove a line. In the drawer specifically,
  // "-" at 1 should remove the item instead. Capture-phase so this runs
  // before quantity-input's own click handler, and delegates to the
  // existing remove button rather than duplicating its fetch logic.
  document.addEventListener(
    'click',
    function (evt) {
      var minusBtn = evt.target.closest('#CartDrawer .quantity__button[name="minus"]');
      if (!minusBtn) return;

      var wrapper = minusBtn.closest('quantity-input');
      var input = wrapper ? wrapper.querySelector('.quantity__input') : null;
      if (!input || parseInt(input.value, 10) > 1) return;

      var removeBtn = minusBtn.closest('.cart-item').querySelector('cart-remove-button button');
      if (!removeBtn) return;

      evt.preventDefault();
      evt.stopImmediatePropagation();
      removeBtn.click();
    },
    true
  );

  if (!customElements.get('cart-shipping-protection')) {
    customElements.define(
      'cart-shipping-protection',
      class CartShippingProtection extends HTMLElement {
        connectedCallback() {
          this.variantId = this.dataset.variantId;
          this.input = this.querySelector('.cart-drawer__protection-input');
          this.input.addEventListener('change', this.onToggle.bind(this));
        }

        onToggle(evt) {
          // cart-drawer-items (Dawn's own CartItems) listens for ANY
          // 'change' event bubbling up from inside it — including this
          // checkbox — and reacts by calling its own updateQuantity()
          // with this checkbox's (nonsensical, for a quantity update)
          // dataset.index/value. Stopping propagation here is what this
          // checkbox's own handler already deals with correctly.
          evt.stopPropagation();
          var checked = this.input.checked;
          this.input.disabled = true;

          var config = fetchConfig('json');
          var url;
          if (checked) {
            url = window.routes.cart_add_url;
            config.body = JSON.stringify({
              items: [{ id: this.variantId, quantity: 1 }],
              sections: cartDrawerSections(),
              sections_url: window.location.pathname,
            });
          } else {
            url = window.routes.cart_change_url;
            config.body = JSON.stringify({
              id: this.variantId,
              quantity: 0,
              sections: cartDrawerSections(),
              sections_url: window.location.pathname,
            });
          }

          fetch(url, config)
            .then(function (response) {
              return response.json();
            })
            .then(function (parsedState) {
              refreshDrawer(parsedState);
            })
            .catch(function (e) {
              console.error(e);
              this.input.checked = !checked;
              this.input.disabled = false;
            }.bind(this));
        }
      }
    );
  }

  if (!customElements.get('cart-discount-code')) {
    customElements.define(
      'cart-discount-code',
      class CartDiscountCode extends HTMLElement {
        connectedCallback() {
          this.applyBtn = this.querySelector('.cart-drawer__discount-apply');
          this.removeBtn = this.querySelector('.cart-drawer__discount-remove');
          this.input = this.querySelector('.cart-drawer__discount-input');
          this.errorEl = this.querySelector('.cart-drawer__discount-error');

          if (this.applyBtn) this.applyBtn.addEventListener('click', this.onApply.bind(this));
          if (this.removeBtn) this.removeBtn.addEventListener('click', this.onRemove.bind(this));
          if (this.input) {
            this.input.addEventListener('keydown', function (evt) {
              if (evt.key === 'Enter') {
                evt.preventDefault();
                this.onApply();
              }
            }.bind(this));
          }
        }

        setDiscount(code) {
          var config = fetchConfig('json');
          config.body = JSON.stringify({
            discount: code,
            sections: cartDrawerSections(),
            sections_url: window.location.pathname,
          });
          return fetch(window.routes.cart_update_url, config).then(function (response) {
            return response.json();
          });
        }

        onApply() {
          var code = this.input.value.trim();
          if (!code) return;
          if (this.errorEl) this.errorEl.hidden = true;
          this.applyBtn.disabled = true;
          this.input.disabled = true;

          this.setDiscount(code)
            .then(function (parsedState) {
              // discount_codes (not cart_level_discount_applications) is the
              // correct signal here — the latter only covers whole-order
              // discounts, so a valid product/collection-specific code would
              // always look "invalid" if checked against it instead.
              var discountCodes = parsedState.discount_codes || [];
              var applied = discountCodes.some(function (dc) {
                return dc.applicable && dc.code && dc.code.toLowerCase() === code.toLowerCase();
              });
              if (!applied) {
                this.applyBtn.disabled = false;
                this.input.disabled = false;
                if (this.errorEl) this.errorEl.hidden = false;
                return;
              }
              refreshDrawer(parsedState);
            }.bind(this))
            .catch(function (e) {
              console.error(e);
              this.applyBtn.disabled = false;
              this.input.disabled = false;
            }.bind(this));
        }

        onRemove() {
          this.removeBtn.disabled = true;
          this.setDiscount('')
            .then(function (parsedState) {
              refreshDrawer(parsedState);
            })
            .catch(function (e) {
              console.error(e);
              this.removeBtn.disabled = false;
            }.bind(this));
        }
      }
    );
  }
})();
